module.exports = __webpack_public_path__ + "static/img/icon_credit.943b92ca.png";